var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/promo-style-macro.j2"] = require( "macros/promo-style-macro.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/promo-header-primary-banner.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/promo-style-macro.j2", false, "core/templates/promo-header-primary-banner.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("promo_include")) {
var t_4 = t_1.promo_include;
} else {
cb(new Error("cannot import 'promo_include'")); return;
}
context.setVariable("p_include", t_4);
output += "<div class=\"dom-header-promo\">\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"primaryHeaderPromo") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"webview") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteDown")) {
output += "\n\n            ";
output += runtime.suppressValue((lineno = 6, colno = 22, runtime.callWrap(t_4, "p_include", context, ["header"])), env.opts.autoescape);
output += "\n\n    ";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/promo-header-primary-banner.j2"] , dependencies)